/**
 * ID | EN, in the header of every mode.
 *
 * Two real buttons rather than a dropdown: one tap on a phone, reachable by
 * keyboard, and the active language is announced through aria-pressed.
 */

import { LOCALES, LOCALE_NAME, LOCALE_SHORT } from "@kikik/i18n";
import { useI18n } from "./LocaleProvider";

export function LanguageSelector() {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="language" role="group" aria-label={t("language.label")}>
      {LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          lang={option}
          className={`language__item ${option === locale ? "language__item--active" : ""}`}
          aria-pressed={option === locale}
          aria-label={t("language.switchTo", { language: LOCALE_NAME[option] })}
          title={LOCALE_NAME[option]}
          onClick={() => setLocale(option)}
        >
          {LOCALE_SHORT[option]}
        </button>
      ))}
    </div>
  );
}
